import { CountryCode } from '../enums/CountryCode';
import { LanguageCode } from '../enums/LanguageCode';
import { Locale } from '../enums/Locale';

interface ICountryAndLAnguageCodes {
  countryCode: CountryCode;
  languageCode: LanguageCode;
}
export const getCountryAndLanguage = (): ICountryAndLAnguageCodes => {
  const [, countryCode = CountryCode.Default, languageCode = LanguageCode.English] =
    /\/(\w{2})\/(\w{2})\/.*/g.exec(window.location.pathname) || [];

  return { countryCode, languageCode } as ICountryAndLAnguageCodes;
};

export const getCountryCode = () => getCountryAndLanguage().countryCode;
export const getLanguageCode = () => getCountryAndLanguage().languageCode;

export function getLocaleAsString() {
  const { countryCode, languageCode } = getCountryAndLanguage();
  return `${languageCode}-${countryCode.toUpperCase()}` as Locale;
}
